module.exports = __webpack_public_path__ + "static/media/lvjian-zhongningfu.0f2162c8.png";